import { CORPORATE_OFFERINGS } from "@/data/site";
import { ButtonLink, Eyebrow, FadeIn } from "@/components/blocks";

export default function CorporateBand() {
  return (
    <section data-testid="corporate-band" className="bg-bone px-6 py-28 text-ink sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto grid max-w-[1440px] gap-16 lg:grid-cols-[1.1fr_1fr] lg:gap-24">
        <div>
          <FadeIn>
            <Eyebrow tone="ink">Corporate Wellness</Eyebrow>
          </FadeIn>
          <FadeIn delay={0.1}>
            <h2 className="mt-8 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl">
              Better people. <span className="text-ink/40">Better workdays.</span>
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-smoke sm:text-lg">
              Modern work is hard on the human body. StrengthLeap corporate programs help teams reduce physical
              discomfort, move more, build healthier habits and improve everyday energy.
            </p>
          </FadeIn>
          <FadeIn delay={0.3} className="mt-10">
            <ButtonLink to="/corporate" variant="outlineInk" testid="corporate-band-cta">
              Talk to Our Corporate Team
            </ButtonLink>
          </FadeIn>
        </div>

        <div>
          {CORPORATE_OFFERINGS.map((o, i) => (
            <FadeIn key={o} delay={i * 0.05}>
              <p className="flex items-center justify-between border-t border-ink/15 py-4 text-sm text-ink/85 last:border-b sm:text-base">
                {o}
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/40">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
